import { useMediaQuery } from "react-responsive";
import { NavigationMobile } from "./Mobile";
import { NavigationDesktop } from "./Desktop";

export function Navigation({ active, links }) {
  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  const Component = isMobile ? NavigationMobile : NavigationDesktop;
  return <Component active={active} links={links} />;
}